import React, { memo } from 'react';
import { I18n } from 'src/modules/common/components/I18n/I18n';

type Props = {
    titleId: string;
    navigation: React.ReactNode;
    breadcrumbs: React.ReactNode;
}

export const MainLayoutHeader = memo(({ titleId, navigation, breadcrumbs }: Props) => (
    <div
        className="vss-main-layout-header"
    >
        <h2 className="vss-main-layout-header__title">
            <I18n messageId={titleId}/>
        </h2>

        {navigation}

        {breadcrumbs}
    </div>
));
